import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import { isArray } from 'lodash';
import { generateRandomId, downloadLocalFile } from 'utility/general';

import CloseIcon from '@material-ui/icons/Close';
import { useDispatch } from 'react-redux';
import { GET_DOWNLOAD_DOCUMENT } from 'store/key';
import { SHyperLink } from 'style/CommonStyledComponent';

const SLayout = styled.div`
    position: relative;
    width: inherit;
`;

const SFileIcon = styled(InsertDriveFileIcon)`
    width: 15px;
    height: 15px;
    color: #808080;
    position: absolute;
    top: ${(props) => (props.top ?? 0) + 6}px;
    left: 5px;
`;

const SCrossIcon = styled(CloseIcon)`
    width: 15px;
    height: 15px;
    color: #808080;
    position: absolute;
    top: ${(props) => (props.top ?? 0) + 6}px;
    right: 5px;
    cursor: pointer;
`;

const SFileItemLayout = styled.div`
    position: absolute;
    top: ${(props) => props.top ?? 0}px;
    left: 0;
    right: ${(props) => props.right ?? 0}px;
    padding: 10px 10px 10px 30px;
    border: 1px solid #b7b7b7;
    border-radius: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const UploadDisplay = ({
    fileList = [], // fileList will be string ??
    enableRemove = false,
    onRemove = (index) => null,
    enableDownload = false,
    downloadId,
    downloadType,
    fileHeight,
    apiUrl,
    newRequestData,
    isLocalDownload,
}) => {
    let data = fileList;

    if (typeof data === 'string') {
        data = [{ name: data }];
    }
    const length = data.length;

    const height = fileHeight ? fileHeight : isArray(data) ? 36 * length + length * 10 : 46;
    const [ids, setIds] = useState(data.map((item) => generateRandomId()));
    const dispatch = useDispatch();

    useEffect(() => {
        let data = fileList;
        if (typeof data === 'string') {
            data = [{ name: data }];
        }

        setIds(data.map((item) => generateRandomId()));
    }, [fileList]);

    const downloadFile = (index, upload) => {
        if (isLocalDownload && upload.file) {
            downloadLocalFile(upload.file);
            return;
        };

        let data = {
            data: {
                id: fileList[index].downloadId,
                type: downloadType,
            },
        };
        if (apiUrl) {
            data = {
                data: {
                    id: fileList[index].downloadId,
                },
                apiUrl,
            };
            if (newRequestData) {
                data.data = newRequestData;
            }
        };

        dispatch({
            type: GET_DOWNLOAD_DOCUMENT,
            payload: data,
        });
    };

    return (
        <SLayout>
            <div
                style={{
                    height: height,
                }}
            >
                {isArray(data) ? (
                    [...Array(length).keys()].map((index) => {
                        const upload = data[index];
                        return (
                            <div key={ids?.[index] ?? generateRandomId()}>
                                <SFileIcon top={36 * index + 10 * index} />
                                <SFileItemLayout
                                    style={{ paddingRight: enableRemove ? 30 : 0 }}
                                    top={36 * index + 10 * index}
                                >
                                    {enableDownload ? (
                                        <SHyperLink href="#" onClick={() => downloadFile(index, upload)}>
                                            {upload.name}
                                        </SHyperLink>
                                    ) : (
                                        upload.name
                                    )}
                                </SFileItemLayout>
                                {enableRemove && (
                                    <SCrossIcon top={36 * index + 10 * index} onClick={() => onRemove(index)} />
                                )}
                            </div>
                        );
                    })
                ) : (
                    <div>
                        <SFileIcon />
                        <SFileItemLayout>{data}</SFileItemLayout>
                    </div>
                )}
            </div>
        </SLayout>
    );
};

export default UploadDisplay;
